// /sports/super-admin/vouchers — ball machine vouchers for the fleet (K6 Phase 4).
// 2026-10-01: the voucher MANAGER (owner-approved mockup prototypes/kiosk-vouchers.html) replaces the flat
// list — machine cards, tiles, tabs, search, batches with their actions and code table, and a drawer with
// each code's history. The same component serves the court's own page in mode="tenant".
// The phone claims at session start and releases on a problem stop; the server computes the discount and
// the split is applied in the ledger — this page only describes batches and shows their state.
import { SuperAdminShell } from './SportsSuperAdminPage';
import KioskVoucherManager from '../kiosk/KioskVoucherManager';

export default function SportsKioskVouchersPage() {
  return (
    <SuperAdminShell title="Vouchers" active="vouchers">
      <main data-testid="sports-kiosk-vouchers-page"
        style={{ padding: '22px 16px 60px', background: 'radial-gradient(1200px 500px at 15% -10%, rgba(255,45,85,.10), transparent 60%), #0B0B0D', minHeight: 'calc(100vh - 110px)' }}>
        <div style={{ maxWidth: 1180, margin: '0 auto' }}>
          <KioskVoucherManager mode="platform" />
        </div>
      </main>
    </SuperAdminShell>
  );
}
